import { Handshake } from "lucide-react";
import { PartnerAdminBody } from "@/components/PartnerAdmin";

export default function PartnerManagementPanel() {
  return (
    <div className="space-y-4" data-testid="partner-mgmt-panel">
      <div className="flex items-center gap-3">
        <div className="grid h-10 w-10 place-items-center rounded-xl bg-slate-900 text-teal-300"><Handshake className="h-5 w-5" /></div>
        <div><h1 className="text-2xl font-bold">Partner Management</h1>
          <p className="text-sm text-slate-500">Partner Hub logins and team leaders, Hub rights, clients, targets, motivation and sales &amp; payments.</p></div>
      </div>
      <div className="rounded-xl border bg-white p-4"><PartnerAdminBody /></div>
    </div>
  );
}
